import React from "react";
import "../css/exam-list.css";
const ExamList = () => {
  return (
    <ul id="exam-stat">
      <li>
        <span className="grey-circle"></span>
        <span className="exam">
          <span>GCE</span>
          <span>
            <span>2340 </span>
            <span> Students</span>
          </span>
        </span>
      </li>
      <li>
        <span className="grey-circle"></span>
        <span className="exam">
          <span>NECO</span>
          <span>
            <span>2340 </span>
            <span> Students</span>
          </span>
        </span>
      </li>
      <li>
        <span className="grey-circle"></span>
        <span className="exam">
          <span>NABTEB</span>
          <span>
            <span>2340 </span>
            <span> Students</span>
          </span>
        </span>
      </li>
      <li>
        <span className="grey-circle"></span>
        <span className="exam">
          <span>WAEC</span>
          <span>
            <span>2340 </span>
            <span> Students</span>
          </span>
        </span>
      </li>
      <li>
        <span className="grey-circle"></span>
        <span className="exam">
          <span>NECO</span>
          <span>
            <span>2340 </span>
            <span> Students</span>
          </span>
        </span>
      </li>
    </ul>
  );
};

export default ExamList;
